import { serviceName } from '../resources/serviceConstants';
import {
  GET_SKILLS,
  ENABLE_OR_DISABLE_SKILLS,
  SKILL_DUMP_UPLOAD,
  SKILL_DUMP_SAMPLE_FILE,
} from '../resources/endPoint';

export const getSkills = (data) => {
  const queryParams = [];

  if (data?.isActiveFlag === true) {
    queryParams.push(`isActiveFlag=${data.isActiveFlag}`);
  }

  if (data?.verticalId) {
    queryParams.push(`verticalId=${data.verticalId}`);
  }

  const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
  const url = `${GET_SKILLS}${queryString}`;

  return {
    url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.SKILLS_MS,
  };
};

// API call to add skill
export const addSkillsData = (skillName, departmentId, verticalId) => {
  const data = {
    skillName: skillName,
    departmentId: departmentId,
    verticalId: verticalId,
  };

  return {
    url: GET_SKILLS,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.SKILLS_MS,
  };
};

// API call to edit skill
export const editSkillsData = (
  skillId,
  skillName,
  departmentId,
  verticalId,
) => {
  const data = {
    skillId: skillId,
    skillName: skillName,
    departmentId: departmentId,
    verticalIds: verticalId,
  };

  return {
    url: GET_SKILLS,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.SKILLS_MS,
  };
};

export const enableOrDisableSkill = (data) => {
  // API call to enable/disable role
  return {
    url: ENABLE_OR_DISABLE_SKILLS,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.SKILLS_MS,
  };
};

export const uploadSkills = (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return {
    url: SKILL_DUMP_UPLOAD,
    method: 'post',
    headers: {
      'content-type': 'multipart/form-data',
    },
    authRequired: true,
    csrfToken: true,
    payload: formData,
    service: serviceName.SKILLS_MS,
    timeout: 300000,
  };
};

export const getSkillsSampleFile = () => {
  return {
    url: SKILL_DUMP_SAMPLE_FILE,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.SKILLS_MS,
  };
};

